module.exports = __webpack_public_path__ + "img/ピン種類.f0da72ae.png";